// Shared email & phone validators used at signup and in account settings.

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * Basic email format validation.
 * Returns an error string, or null if valid.
 */
export function validateEmail(email) {
  if (!email || !email.trim()) return "Email is required.";
  const trimmed = email.trim();

  if (!EMAIL_REGEX.test(trimmed)) return "Please enter a valid email address (e.g. you@company.com).";

  if ((trimmed.match(/@/g) || []).length > 1)
    return "Email address cannot contain multiple @ signs.";

  const [, domain] = trimmed.split("@");
  const parts = domain.split(".");
  for (const part of parts) {
    if (part.length === 0) return "Email address has consecutive dots or an invalid format.";
  }

  return null; // valid
}

/**
 * Validates a phone number for obvious errors.
 * Phone is optional — returns null (valid) when empty.
 */
export function validatePhone(phone) {
  if (!phone) return null;
  const stripped = phone.replace(/[\s\-().+]/g, "");
  if (!/^\d{7,15}$/.test(stripped))
    return "Phone number should be 7–15 digits. Include country code, e.g. +1 555 555 0100.";
  if (/^(\d)\1{9,}$/.test(stripped))
    return "Phone number doesn't look valid. Please enter a real number.";
  return null;
}
